import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import styled from 'styled-components'

import Select from 'components/Shared/Select/Index'

const StyledSelect = styled(Select)`
  min-width: 160px;
`

const PORTAL_Z_INDEX = 10001

const getOptions = (fields) => {
  return fields.map(field => ({
    value: field.name,
    label: field.name,
  }))
}

const ColumnSelectField = ({
  name, filterFields, isLoading, onChange,
}) => {
  const { t } = useTranslation()

  const fields = filterFields.filter(field => !field.isDynamic)
  const dynamicFields = filterFields.filter(field => field.isDynamic)
  const groupedOptions = [
    {
      label: t('ticketsPage.filterForm.allFieldsLabel'),
      options: getOptions(fields),
    },
    {
      label: t('ticketsPage.filterForm.dynamicFieldsLabel'),
      options: getOptions(dynamicFields),
    },
  ]

  const onChange_ = (value, callback) => {
    onChange?.(value)
    callback(value)
  }

  return (
    <Field
      name={name}
    >
      {({ input, meta }) => {
        return (
          <StyledSelect
            small
            isLoading={isLoading}
            value={input.value}
            onChange={(value) => onChange_(value, input.onChange)}
            options={groupedOptions}
            placeholder={t('ticketsPage.filterForm.selectFieldPlaceholder')}
            usePortal
            portalZindex={PORTAL_Z_INDEX}
            dataTest='column'
          />
        )
      }}
    </Field>
  )
}

ColumnSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  filterFields: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
}

export default ColumnSelectField
